import { useState } from 'react';

import { BookmarkIcon, CheckIcon, ChevronsUpDownIcon } from 'lucide-react';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';

import { SavedFilterView } from './ComplexFilterBar';

interface SavedFilterSelectorProps {
  savedFilters: SavedFilterView[];
  activeSavedFilter: SavedFilterView;
  onSelectView?: (viewId: string) => void;
}

export const SavedFilterSelector = ({
  savedFilters,
  activeSavedFilter,
  onSelectView,
}: SavedFilterSelectorProps) => {
  const [open, setOpen] = useState(false);
  const hasMultipleViews = savedFilters.length > 1;

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <InfoTooltip content={activeSavedFilter.name} side="top" size="large">
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost-neutral"
            className={cn(
              'h-auto gap-1.5 px-2 py-1.5 font-semibold',
              !hasMultipleViews && 'cursor-default hover:bg-transparent'
            )}
          >
            <BookmarkIcon />
            <span className="max-w-32 truncate">{activeSavedFilter.name}</span>
            {hasMultipleViews && <ChevronsUpDownIcon />}
          </Button>
        </DropdownMenuTrigger>
      </InfoTooltip>
      {hasMultipleViews && onSelectView && (
        <DropdownMenuContent align="start" className="min-w-40">
          {savedFilters.map((view) => (
            <DropdownMenuItem
              key={view.id}
              className="relative pr-8"
              onSelect={() => onSelectView(view.id)}
            >
              {view.name}
              {view.id === activeSavedFilter.id && (
                <CheckIcon size={16} className="absolute right-2 text-accent" />
              )}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      )}
    </DropdownMenu>
  );
};
